import React from "react";
import "../App.css";
import Badge from "./Badge";
import ExDataTable from "./ExDataTable";
import Hero from "./Hero";
import PortfolioCard from "./PortfolioCard";
import Profile from "./Profile";
import Review from "./Review";
import SecParagraph from "./SecParagraph";
import SectionTitle from "./SectionTitle";
import ServiceCard from "./ServiceCard";
import SubTitle from "./SubTitle";
import Tools from "./Tools";
import myVideo from "../assets/media/daystarbg.mp4";
import Motiontext from "./Motiontext";
import Footer from "./Footer";
import ProjectImg01 from "../assets/media/pro01.png";
import ProjectImg02 from "../assets/media/pro02.png";
import ProjectImg03 from "../assets/media/pro03.png";
import ProjectImg04 from "../assets/media/pro04.png";
import ProjectImg05 from "../assets/media/pro05.png";
import ProjectImg06 from "../assets/media/pro06.png";

function Home() {
  return (
    <>
      <div className="fix-div-01"></div>
      <div className="fix-div-02"></div>
      <div className="fix-div-03">
        <video autoPlay muted loop>
          <source src={myVideo} type="video/mp4" />
        </video>
      </div>
      <div id="main-sec">
        {/* <div className="fixed-sec">
    <Profile />
  </div> */}
        <div className="Portfolio-con">
          <Hero />

          <Badge title="About Me" />
          <SectionTitle sectitle="Turning complex problems into simple design" />
          <SecParagraph data="Hi, I'm Dilip Suthar, a passionate Full-Stack Web Developer with expertise in front-end and back-end technologies. With experience in HTML, CSS, Bootstrap, JavaScript, React, jQuery, PHP, and MySQL, I specialize in creating modern, responsive, and high-performance websites." />

          <SecParagraph data="I have worked on live projects with companies like Bigxtech and Future Core Innovation, gaining hands-on experience in web development. Currently, I run Skilltech Academy, where I provide online and offline courses to help aspiring developers grow their skills." />

          <SecParagraph data="My goal is to deliver innovative digital solutions, whether it's a custom website, e-commerce platform, or web application. I also offer landing page development services on Fiverr and work on various client projects." />

          <Motiontext />

          <Badge title="PortFolio" />
          <SectionTitle sectitle="Check out my featured projects" />

          {/* portfolio card sec */}

          <div id="portfolio-sec">
            <PortfolioCard
              Cardtitle="BigXTech — IT Services & Product Company"
              Carddesc="A fully responsive company website with service pages, product listings, business overview."
              url="https://bigxtech.com/"
              CardImg={ProjectImg03}
            />

            <PortfolioCard
              Cardtitle="ZenoConceal "
              Carddesc="A clean and simple online tool that lets users hide, blur, or mask sensitive text and images."
              url="https://zenoconceal.com/"
               CardImg={ProjectImg01}
            />

            <PortfolioCard
              Cardtitle="RajShah Photography — Photography Website"
              Carddesc="
            At Raj Shah Photography, we don’t just take pictures—we preserve your story with creativity, passion, and perfection. 
            "
              url="https://rajshahphotography.com/"
               CardImg={ProjectImg02}
            />

            <PortfolioCard
              Cardtitle=" SmartQR Tech — QR Generator Platform "
              Carddesc="A fast and modern QR code generator where users can create dynamic and static QR codes. "
              url="https://smartqrtech.com/"
               CardImg={ProjectImg04}
            />

            <PortfolioCard
              Cardtitle="AtmanirbharAcademy — Learning Platform"
              Carddesc="
            An educational platform offering courses, student resources, and instant form submissions. 
            "
              url="https://atmanirbharacademy.com/"
               CardImg={ProjectImg05}
            />

            <PortfolioCard
              Cardtitle="OfficeWallah — Online Form + Google Sheet Sync"
              Carddesc="A complete form system where user submissions automatically save to a connected Google Sheet"
              url="https://officewallah.in/"
               CardImg={ProjectImg06}
            />
          </div>

          <Badge title="Resume" />
          <SectionTitle sectitle="Education and practical experience" />
          <SecParagraph data="I have worked on live projects with companies like Bigxtech and Future Core Innovation, gaining hands-on experience in web development. Currently, I run Skilltech Academy, where I provide online and offline courses to help aspiring developers grow their skills." />

          <div className="ex-sec">
            <SubTitle subtitle="My education" />
            <ExDataTable
              year="2017-2019"
              extitle="9th - 10th Grade"
              exdesc="Arya Samaj School"
              exdata="Focused on foundational academic subjects, improved logical thinking, and participated in school activities and basic computer learning."
            />
            <ExDataTable
              year="2019-2021"
              extitle="11th - 12th Grade"
              exdesc="G.S.S.S Sumerpur"
              exdata="Completed senior secondary education with academic excellence, stream focus, practical skills, and preparation for competitive and entrance examinations."
            />
            <ExDataTable
              year="2021-2025"
              extitle="B.Tech [ CSE ]"
              exdesc="CLG Institute of Engineering & Technology"
              exdata="Studied core computer science subjects, including programming, data structures, web development, and software engineering with hands-on project experience."
            />
          </div>

          <div className="ex-sec">
            <SubTitle subtitle="Work experience" />
            <ExDataTable
              year="Nov 2022 - Jan 2024"
              extitle="Frontend Developer Intern"
              exdesc="Bigxtech"
              exdata="Worked on real-world web projects using HTML, CSS, JavaScript, and React. Gained hands-on experience in UI/UX development."
            />

            <ExDataTable
              year="Mar 2024 - Oct 2024"
              extitle="Frontend Developer"
              exdesc="Future Core Innovations"
              exdata="Developed and maintained responsive websites and landing pages. Improved performance and collaborated with backend team for full integration."
            />

            <ExDataTable
              year="Nov 2024 - Present"
              extitle="Web Developer"
              exdesc="Vistavoyage Solutions Pvt Ltd"
              exdata="Building dynamic travel websites, integrating APIs, and handling frontend-to-backend communication for real-time booking and user experience."
            />
          </div>

          <Badge title="Services Serve By Me" />

          <SectionTitle sectitle="Turning complex problems into simple design" />

          <div id="portfolio-sec">
            <ServiceCard
              title="Website Design & Development"
              tech="HTML"
              desc="I create fast, responsive, and visually appealing websites tailored to your brand using modern web technologies and clean, SEO-friendly code."
            />

            <ServiceCard
              title="Responsive Landing Page"
              tech="Student"
              desc="I design high-converting, mobile-friendly landing pages that load fast, look stunning, and effectively capture leads or drive user actions."
            />

            <ServiceCard
              title="E-Commerce Website Development"
              tech="PHP"
              desc="I build secure, user-friendly e-commerce websites with product management, cart, checkout, payment gateway, and responsive design for seamless shopping."
            />

            <ServiceCard
              title="Admin Panel & Dashboard Development"
              tech="PHP"
              desc="I develop powerful admin panels with user roles, real-time data, CRUD operations, and analytics for efficient website or app management."
            />

            <ServiceCard
              title="CMS Integration"
              tech="Web"
              desc="I integrate custom or open-source CMS platforms to easily manage website content, blogs, images, and dynamic pages without coding."
            />

            <ServiceCard
              title="Graphic Design"
              tech="Logo Banner"
              desc="I create visually appealing logos, banners, posters, and social media creatives that enhance branding, engagement, and overall visual identity."
            />
          </div>

          <Badge title="Tools" />
          <SectionTitle sectitle="My favourite tools" />
          <Tools />

          <Badge title="Testimonials" />
          <SectionTitle sectitle="What my clients say" />

          <Review />
          <Footer />
        </div>
      </div>
    </>
  );
}

export default Home;
